import { badge } from "src/utils/statusColorsCode"

export const ProgramNameHandler = ({ data,kycDetails }) => {
    return (
        <td onClick={kycDetails(data)}>
            <span className=' text-link cursor-pointer'>{data?.programName}</span>
        </td>
    )
}
export const KycStatusHandler = ({ data }) => {
    return (
        <td>
                <span className={`status-badge ${badge[data?.state?.toLowerCase()] || 'bg-green'}`}>{data?.state}</span>
        </td>
    )
}                     